var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"value":_vm.value,"disabled":_vm.disabled,"placeholder":_vm.label,"clearable":""},on:{"change":_vm.onChange}},_vm._l((_vm.data),function(item){return _c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.roleName}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }